import Context from "../../context/Context";
import Source from "../base/Source";

export function appendTokenToUrl(url) {
  if (url && url.indexOf("token=") === -1) {
    let token = null;
    const credential = Context.getInstance().lib.esri.esriId.findCredential(url);
    if (credential) {
      token = credential.token;
    }
    if (token) {
      if (url.indexOf("?") === -1) url += "?";
      else url += "&";
      url += "token="+encodeURIComponent(token);
    }
  }
  return url;
}

export function findAttributeName(attributes, name) {
  if (!attributes) return null;
  if (attributes.hasOwnProperty(name)) return name;
  let found = null, lc = name.toLowerCase();
  Object.keys(attributes).some(key => {
    if (key.toLowerCase() === lc) {
      found = key;
      return true;
    }
    return false;
  });
  return found;
}

export function findField(fields, name) {
  let found = null;
  if (fields && fields.length > 0 && name) {
    const lc = name.toLowerCase();
    fields.some(field => {
      if (lc === field.name.toLowerCase()) {
        found = field;
        return true;
      }
      return false;
    });
  }
  return found;
}

export function findFieldName(fields, name) {
  const field = findField(fields,name);
  if (field) return field.name;
  return null;
}

export function findObjectIdField(fields) {
  let objectIdField = null;
  if (fields && fields.length > 0) {
    fields.some(field => {
      if (field.type === "oid") {
        objectIdField = field.name;
        return true;
      }
      return false;
    });
  }
  return objectIdField;
}

export function getAttributeValue(attributes, name) {
  if (!attributes || !name) return;
  if (typeof name !== "string") return;
  if (attributes.hasOwnProperty(name)) return attributes[name];
  let value, lc = name.toLowerCase();
  Object.keys(attributes).some(key => {
    if (key.toLowerCase() === lc) {
      value = attributes[key];
      return true;
    }
    return false;
  });
  return value;
}

export function getLayers(view) {
  if (view) {
    const layers = view.map.layers.flatten(function(item) {
      return item.layers || item.sublayers;
    });
    return layers;
  }
  return [];
}

export function getSource(sourceKey) {
  const categories = Context.getInstance().aiim.datasets.categories;
  return categories.findSourceByKey(sourceKey);
}

export function hasAttribute(attributes, name) {
  if (!attributes) return false;
  if (typeof name !== "string") return false;
  let found = false, lc = name.toLowerCase();
  Object.keys(attributes).some(key => {
    if (key.toLowerCase() === lc) {
      found = true;
    }
    return found;
  });
  return found;
}

export function lookupDomainValue(source,feature,fieldName) {
  let v = getAttributeValue(feature.attributes,fieldName);
  if (v === null || v === undefined) return v;
  let layer = source.layer2D;
  if (!layer) return v;
  let field = findField(layer.fields,fieldName);
  if (!field) return v;

  if (typeof layer.getFeatureType === "function") {
    const typeIdField = layer.typeIdField;
    if (typeof typeIdField === "string" &&
        typeIdField.toLowerCase() === field.name.toLowerCase()) {
      const featureType = layer.getFeatureType(feature);
      if (featureType) return featureType.name;
    }
  }

  if (field.domain && field.domain.type === "coded-value") {
    let codedValues = field.domain.codedValues;
    if (codedValues && codedValues.hasOwnProperty(v)) {
      let codedValue = codedValues[v];
      if (codedValue) {
        return codedValue.name;
      }
    }
  }

  // if (typeof layer.getFieldDomain === "function") {
  //   console.log("field",field.name.field);
  //   const domain = layer.getFieldDomain(field.name, {
  //     feature: feature
  //   });
  //   console.log(fieldName,"domain",domain)
  //   if (domain && domain.type === "coded-value") {
  //     return domain.getName(v);
  //   }
  // }

  return v;
}

export function readServiceJson(url) {
  const lib = Context.getInstance().lib;
  url = Context.checkMixedContent(url);
  const options = {query: {f: "json"}, responseType: "json"};
  return lib.esri.esriRequest(url,options);
}

export function removeShapeAttributes(attributes) {
  if (!attributes) return;
  const names = [];
  Object.keys(attributes).forEach(key => {
    const lc = key.toLowerCase();
    if (lc === "shape_area" || lc === "shape_length" || lc === "shape_len" ||
        lc === "shape__area" || lc === "shape__length" || lc === "shape__len" ||
        lc === "shape.area" || lc === "shape.length" || lc === "shape.len" ||
        lc === "shape.starea()" || lc === "shape.stlength()") {
      names.push(key);
    }
  });
  names.forEach(name => {
    delete attributes[name];
  });
}

export function waitForLayer(layer) {
  const promise = new Promise((resolve,reject) => {
    if (layer && typeof layer.when === "function") {
      layer.when(() => {
        resolve(layer);
      }).catch(ex => {
        console.error("Error while waiting for layer:",ex);
        resolve(); // reject?
      });
    } else {
      resolve();
    }
  });
  return promise;
}

export function waitForLayers(view,layers) {
  const promises = [];
  if (!layers) layers = getLayers(view);
  layers.forEach(layer => {
    promises.push(waitForLayer(layer));
  });
  if (promises.length > 0) {
    return Promise.all(promises);
  }
  return Promise.resolve();
}

export function isDetailsLayer(layer) {
  const title = layer.title
  if (title === "Details") return true
  else return false
}

export function makeReservationsSource(task) {
  const reservationsSource = task.sources.find((src) => src.key === "Reservations");
  if (reservationsSource) {
    return;
  }

  const view = Context.getInstance().views.mapView;
  const layers = getLayers(view);
  const reservationsLayer = layers.find((layer) => layer.title.toLowerCase() === "reservations");

  if (reservationsLayer && reservationsLayer.declaredClass !== "esri.layers.support.Sublayer") {
    const source = new Source({
      key: "Reservations",
      name: "Reservations"
    });
    source.uniqueIdField = reservationsLayer.objectIdField;
    source.url = `${reservationsLayer.url}/${reservationsLayer.layerId}`;
    source.displayField = reservationsLayer.displayField;
    source.layer2D = reservationsLayer;

    task.sources.push(source);
  }
}
